// storageService.ts
import { Storage, Drivers } from '@ionic/storage';

const storage = new Storage({
  name: "__user",
  driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
});

storage.create();

export default storage;